import { render, staticRenderFns } from "./Latihan.vue?vue&type=template&id=17c3e89a&"
import script from "./Latihan.vue?vue&type=script&lang=js&"
export * from "./Latihan.vue?vue&type=script&lang=js&"
import style0 from "./Latihan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports